import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import styled from 'styled-components';
import { lazy } from 'react';
import loadable from '@loadable/component';
import theme from '@airasia-common/libraries/theming/theme';
import { setCurrentDeviceAgent } from '@airasia-common/libraries/utilities/DeviceAgentHelper';

import { deviceAgentDetect } from './utils/DeviceAgent';
import { constants, useWindowSize } from './utils';
import {
  DEFAULT_META_DESC,
  DEFAULT_META_KEYWORDS,
  ROBOTS_DEFAULT,
} from './utils/constants';

const HeadHelmet = lazy(() =>
  import(
    /* webpackChunkName: "vendor.aa-react-dom" */
    '@airasia-common/react-dom/components/HeadHelmet/HeadHelmet'
  ).then(m => ({ default: m.HeadHelmet }))
);

const StoreProvider = loadable(() => import('./providers/StoreProvider'));
// ─── Lazy route-level chunks ───────────────────────────────────────────────
const Home = loadable(() =>
  import(
    /* webpackChunkName: "view.home" */
    './views/Home'
  )
);

const Hotel = loadable(() =>
  import(
    /* webpackChunkName: "view.hotel" */
    './views/Hotel'
  )
);

// ─── App shell ────────────────────────────────────────────────────────────
const Main = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
`;
const InlineSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: 64 }}>
    <div
      style={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        border: '3px solid #eee',
        borderTopColor: '#e8173b',
        animation: 'aa-spin 0.8s linear infinite',
      }}
    />
    <style>{'@keyframes aa-spin { to { transform: rotate(360deg) } }'}</style>
  </div>
);

function App() {
  setCurrentDeviceAgent(deviceAgentDetect);

  const { isMobileView } = useWindowSize();

  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback={<InlineSpinner />}>
        <StoreProvider loading={<InlineSpinner />}>
          <Router>
            <Main>
              <HeadHelmet
                metaDescription={DEFAULT_META_DESC}
                metaKeywords={DEFAULT_META_KEYWORDS}
                cannonicalUrl={
                  'https://www.airasia.com' + window.location.pathname
                }
                metaRobots={ROBOTS_DEFAULT}
              />
              <Switch>
                <Route path={constants.ROUTE.HOTEL.ROOT}>
                  <Hotel isMobileView={isMobileView} />
                </Route>
                <Route path={constants.ROUTE.ROOT}>
                  <Home />
                </Route>
              </Switch>
            </Main>
          </Router>
        </StoreProvider>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
